<template>
  <v-card style="cursor: pointer"
    @click="$emit('click', project)"
  >
    <v-img :src="image" :lazy-src="base64" />
    <v-card-title primary-title>
      <v-layout column class="pa-2">
        <h3 class="headline mb-0">{{ project.title }}</h3>
        <div>{{ project.short_description }}</div>
        <skill-bar :skills="project.skills" />
      </v-layout>
    </v-card-title>

    <v-divider />
    <v-card-actions>
      <v-btn flat v-for="(link, index) in project.links"
        :key="index"
        :href="link.url" target="_blank"
        @click.stop="">
        {{ link.title }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import SkillBar from '@/components/projects/SkillBar.vue';

export default {
  props: ['project'],
  components: {
    'skill-bar': SkillBar,
  },

  computed: {
    image() {
      let root = '/img/projects';
      return `${root}/${this.project.image}`;
    },
    base64() {
      let prefix = 'data:image/jpeg;base64,';
      return prefix + this.project.base64;
    },
  },
};
</script>
